import { Workbook } from 'exceljs';

import { DocumentMedicalBillEntity } from '../../../generated-api';
import { ResultPageDocument } from '../defs/types';
import { isPharmacy } from './isPharmacy';

const MAX_ENTRIES = 995;
const MAX_PATIENT_NAME_LENGTH = 10;
const MAX_HOSPITAL_NAME_LENGTH = 20;
const MAX_AMOUNT_DIGITS = 9;
const TEMPLATE_START_ROW = 9;

export async function convertToMedicalExpenseSummaryForm(
  values: ResultPageDocument<DocumentMedicalBillEntity>[]
): Promise<Workbook> {
  if (values.length > MAX_ENTRIES) {
    throw new Error('医療費集計フォームの上限を超えています。995件以下にしてください。');
  }
  // 元ファイルは public/iryouhi_form_v3.xlsx に配置
  const response = await fetch('/iryouhi_form_v3.xlsx');
  if (!response.ok) {
    throw new Error(`テンプレートファイルの読み込みに失敗しました: ${response.statusText}`);
  }
  const arrayBuffer = await response.arrayBuffer();

  const workbook = new Workbook();
  await workbook.xlsx.load(arrayBuffer);

  const sheet = workbook.getWorksheet('医療費集計フォーム');
  if (!sheet) {
    throw new Error('「医療費集計フォーム」シートが見つかりません');
  }

  values
    .filter((item) => !item.error)
    .forEach((value, index) => {
      const rowNumber = TEMPLATE_START_ROW + index;
      const entity = value.latest_revision;
      const hospitalName = entity.hospital_name || '';

      if (entity.patient_name && entity.patient_name.length > MAX_PATIENT_NAME_LENGTH) {
        throw new Error(`受診者名が10文字を超えています: ${index + 1}行目  ${entity.patient_name}`);
      }
      if (entity.hospital_name && entity.hospital_name.length > MAX_HOSPITAL_NAME_LENGTH) {
        throw new Error(`医療機関名が20文字を超えています: ${index + 1}行目  ${entity.hospital_name}`);
      }
      if (entity.amount && entity.amount.toString().length > MAX_AMOUNT_DIGITS) {
        throw new Error(`金額が9桁を超えています: ${index + 1}行目  ${entity.amount}`);
      }

      sheet.getCell(`B${rowNumber}`).value = entity.patient_name || '';
      sheet.getCell(`C${rowNumber}`).value = entity.hospital_name || '';
      sheet.getCell(`D${rowNumber}`).value = isPharmacy(hospitalName) ? '' : '該当する';
      sheet.getCell(`E${rowNumber}`).value = isPharmacy(hospitalName) ? '該当する' : '';
      sheet.getCell(`H${rowNumber}`).value = entity.amount || 0;
      sheet.getCell(`J${rowNumber}`).value = entity.date || '';
    });

  // M列で D列からG列までの選択肢の値を設定しているため、M列を非表示にする
  sheet.getColumn('M').hidden = true;

  return workbook;
}
